export class EmptyClass {

}
